import { Component } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { HttpClient, HttpParams } from '@angular/common/http';
import { ComboServices } from '../../services';
import { MenuServices } from '../../../menu/services';
import { PosComboPage } from '../../../components/pos/pos-combo/pos-combo';
import * as firebase from 'firebase';

@Component({
  selector: 'page-combo-view-simulator',
  templateUrl: 'combo-view-simulator.html',
})
export class ComboViewSimulatorPage {
  menu_uid;
  combo_name;
  firestore;
  loader_sections_sold: boolean = false;

  constructor(
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public comboServices: ComboServices,
    public menuServices: MenuServices,
    public modalCtrl: ModalController) {
    this.firestore = firebase.firestore();
    //limpiamos el array del simulador
    this.comboServices.renewSimulator();
    this.combo_name = this.navParams.get('combo_title');
    this.start();
  }

  /**********************************************************/
  /*                          INIT                          */
  /**********************************************************/

  async start() {
    this.loader_sections_sold = true;
    await this.globals.delay(2000);
    this.menu_uid = this.menuServices.menu_tmp.UID;
    this.getAllAnalytics();
    this.getComboSoldSectionsAnalytics();
  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/

  openAddCombo() {
    let profileModal = this.modalCtrl.create(PosComboPage,
      {
        combo: this.menuServices.menu_tmp,
        origin: 'simulator'
      });
    profileModal.onDidDismiss(data => { });
    profileModal.present();
  }

  //Analitica informació allergens, categories i foodcost
  async getAllAnalytics() {
    this.getMargeOfMenuCombo();
  }

  public menu_combo_foodcost_max = 0;
  public menu_combo_average_max_percentage = 0;
  public menu_combo_benefit_max = 0;
  public menu_combo_benefit_max_percentage = 0;

  public menu_combo_foodcost_min = 0;
  public menu_combo_average_min_percentage = 0;
  public menu_combo_benefit_min = 0;
  public menu_combo_benefit_min_percentage = 0;

  public menu_combo_foodcost = 0;
  public menu_combo_average_sections = 0;
  public menu_combo_average_percentage = 0;

  public menu_combo_benefit = 0;
  public menu_combo_benefit_percentage = 0;

  public menu_combo_price_extra = 0;
  public menu_combo_price_extra_max = 0;
  public menu_combo_price_extra_min = 0;
  public menu_combo_price_no_tax = 0;
  public menu_combo_price_no_tax_max = 0;
  public menu_combo_price_no_tax_min = 0;

  public sections = [];

  public menu_combo_no_foodcost = false;
  public menu_combo_no_foodcost_list = [];
  public menu_combo_no_section_elements = false;

  public loader = true;

  async getMargeOfMenuCombo() {

    const body = new HttpParams()
      .set('uid_menu_combo', this.menu_uid);

    await this.http.post(this.globals.analytics_path + 'bimenucombo/get_marge_of_combo', body).subscribe(async res => {

      this.loader = true;
      this.menu_combo_foodcost_max = res['menu_combo_foodcost_max'];
      this.menu_combo_average_max_percentage = res['menu_combo_average_max_percentage'];
      this.menu_combo_benefit_max = res['menu_combo_benefit_max'];
      this.menu_combo_benefit_max_percentage = res['menu_combo_benefit_max_percentage'];

      this.menu_combo_foodcost_min = res['menu_combo_foodcost_min'];
      this.menu_combo_average_min_percentage = res['menu_combo_average_min_percentage'];
      this.menu_combo_benefit_min = res['menu_combo_benefit_min'];
      this.menu_combo_benefit_min_percentage = res['menu_combo_benefit_min_percentage'];

      this.menu_combo_foodcost = res['menu_combo_foodcost'];
      this.menu_combo_average_sections = res['menu_combo_average_sections'];
      this.menu_combo_average_percentage = res['menu_combo_average_percentage'];

      this.menu_combo_benefit = res['menu_combo_benefit'];
      this.menu_combo_benefit_percentage = res['menu_combo_benefit_percentage'];

      this.menu_combo_price_extra = res['menu_combo_price_extra'];
      this.menu_combo_price_extra_max = res['menu_combo_price_extra_max'];
      this.menu_combo_price_extra_min = res['menu_combo_price_extra_min'];

      this.menu_combo_price_no_tax = res['menu_combo_price_no_tax'];
      this.menu_combo_price_no_tax_max = res['menu_combo_price_no_tax_max'];
      this.menu_combo_price_no_tax_min = res['menu_combo_price_no_tax_min'];

      this.sections = res['sections'];

      this.menu_combo_no_foodcost = res['menu_combo_no_foodcost'];
      this.menu_combo_no_foodcost_list.push(res['menu_combo_no_foodcost_list']);
      this.menu_combo_no_section_elements = res['menu_combo_no_section_elements'];

      this.loader = false;

    });
  }

  getColor(percentatge) {
    if (percentatge <= 33) {
      return "red";
    } else if (percentatge > 33 && percentatge <= 66) {
      return "orange";
    } else {
      return "green";
    }
  }

  getColorBackground(percentatge) {
    if (percentatge <= 33) {
      return "#ec632a";
    } else if (percentatge > 33 && percentatge <= 66) {
      return "#ffa500";
    } else {
      return "#5bb189";
    }
  }

  fillCharactersRight(text) {
    let max = 75;
    var t_length = text.toString().length;
    var a_length = max - parseInt(t_length);
    if (t_length < max) {
      for (var _i = 0; _i < a_length; _i++) {
        text = text + '\xa0';
      }
    }
    return text;
  }

  comboSoldSections: any = [];
  async getComboSoldSectionsAnalytics() {
    var orders = [];
    var all = [];
    await this.firestore.collection('orders')
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('show_kitchen', '==', true)
      .orderBy('created_at', 'desc')
      .get()
      .then((snapshot) => {
        if (snapshot.size > 0) {
          snapshot.forEach((doc) => {
            var data = doc.data();
            data.UID = doc.id;
            all.push(data);
            let _order = this.filterAllCombos(data, this.menu_uid);
            if (_order.list.length > 0) {
              orders.push(data);
            }
          });
        }
      });
    //
    this.comboSoldSections = await this.countAndTransformSalesBySection(orders);
    this.loader_sections_sold = false;
  }

  countAndTransformSalesBySection(orders) {
    const salesCount = {};
    // Count items sold per section
    orders.forEach(order => {
      order.sections.forEach(section => {
        const sectionName = section.name;
        // Skip the "Menu" section
        if (sectionName === "Menu") {
          return;
        }
        // Initialize the section in the result if not present
        if (!salesCount[sectionName]) {
          salesCount[sectionName] = {};
        }
        // Iterate through the items in the section
        section.list.forEach(item => {
          // Filter out items that do not have a uid_element_combo
          if (!item.uid_element_combo) {
            return;
          }
          const itemName = item.name;
          // Initialize the item count if not present
          if (!salesCount[sectionName][itemName]) {
            salesCount[sectionName][itemName] = 0;
          }
          // Increment the item count
          salesCount[sectionName][itemName]++;
        });
      });
    });
    // Transform the result and find the most sold item per section
    const transformedResult = Object.keys(salesCount).map(sectionName => {
      let itemsArray = Object.keys(salesCount[sectionName]).map(itemName => {
        return { name: itemName, quantity: salesCount[sectionName][itemName] };
      });
      // Sort items by quantity sold, descending
      itemsArray.sort((a, b) => b.quantity - a.quantity);
      // Return the section with sorted items and the most sold item
      return {
        section: sectionName,
        items: itemsArray,
        most_sold: itemsArray.length > 0 ? itemsArray[0] : null // Handle case with no items
      };
    });
    // Filter out sections with no items
    return transformedResult.filter(section => section.items.length > 0);
  }


  filterAllCombos(order, combo_uid) {
    var _combos = {
      name: 'Combos',
      combo: true,
      list: []
    };
    for (let section of order.sections) {
      if (section.only_combo == undefined || section.only_combo == false) {
        //
        if (section.name === 'Menu') {
          for (let element_combo of section.list) {
            if (element_combo.uid_combo_tmp >= 0 && element_combo.uid_element == combo_uid) {
              //es un combo (crear section combos para insertar los elementos abajo)
              var combo_section = {
                name: element_combo.name,
                uid_combo_tmp: element_combo.uid_combo_tmp,
                uid_combo: element_combo.uid_element,
                sections: [],
                finish: element_combo.finish,
                comment: element_combo.comment || ''
              };

              //buscar elementos combo
              for (let _section of order.sections) {
                var _section_combo_list = { name: '', list: [] };
                if (_section.name !== 'Menu') {
                  _section_combo_list = {
                    name: _section.name,
                    list: []
                  };
                }
                for (let _element of _section.list) {
                  if (_element.uid_combo_tmp === element_combo.uid_combo_tmp && _section.name !== 'Menu') {
                    //elementos combo
                    _section_combo_list.list.push(_element);
                  }
                }
                if (_section_combo_list.list && _section_combo_list.list.length > 0) {
                  if (Object.keys(_section_combo_list).length > 0) {
                    combo_section.sections.push(_section_combo_list);
                  }
                }
              }
              //
              if (Object.keys(combo_section.sections).length > 0) {
                _combos.list.push(combo_section);
              } else {
                _combos.list.push(combo_section);
              }
            }
          }
        }
      }
    }
    return _combos;
  }

}


// WEBPACK FOOTER //
// ./src/pages/combo/combo-view/combo-view-simulator/combo-view-simulator.ts